import { createDoc, updateDoc } from "../../../utils/docsApi";

const GENERIC_DOC_ERROR = "We couldn't create the doc. Please try again.";

function normalizeCreatedDoc(data) {
  if (!data?.docId) {
    throw new Error(GENERIC_DOC_ERROR);
  }
  return {
    docId: data.docId,
    title: data.title || "Untitled",
    version: data.version,
  };
}

/** Blank doc for the AI "seed then configure" path. */
export async function createBlankDocForPrompt() {
  const res = await createDoc({
    title: "Untitled",
    parentDocId: null,
  });
  if (!res.ok) {
    throw new Error(GENERIC_DOC_ERROR);
  }
  return normalizeCreatedDoc(res.data);
}

/** Manual setup: empty page the user fills in themselves. */
export async function createBlankDoc() {
  return createBlankDocForPrompt();
}

/** Template path: create with body, then promote to skill when needed. */
export async function createDocFromTemplate(template) {
  if (!template) {
    throw new Error(GENERIC_DOC_ERROR);
  }

  const res = await createDoc({
    title: template.title,
    parentDocId: null,
    icon: template.icon,
    bodyMarkdown: template.bodyMarkdown,
  });
  if (!res.ok) {
    throw new Error(GENERIC_DOC_ERROR);
  }

  let doc = res.data;

  if (template.docType === "skill" && template.skillName) {
    const updateRes = await updateDoc(doc.docId, {
      title: template.title,
      bodyMarkdown: template.bodyMarkdown,
      expectedVersion: doc.version,
      docType: "skill",
      skillName: template.skillName,
      skillDescription: template.skillDescription || "",
    });
    if (updateRes.ok) {
      doc = updateRes.data;
    }
    // ponytail: page exists even if skill promotion fails; user can fix in editor
  }

  return normalizeCreatedDoc(doc);
}

export function buildDocEditorLocation(docId, { prompt } = {}) {
  const params = new URLSearchParams({ docId });
  const trimmedPrompt = String(prompt || "").trim();
  if (trimmedPrompt) {
    params.set("docAgentPrompt", trimmedPrompt);
  }
  return `/docs?${params.toString()}`;
}
